<div *ngIf="toolbar" class='pers-toolbar' [ngClass]="persCSSClassDiv">
    <!--class="toolbar" [ngClass]="toolbar.toolbarCss" -->
    <ng-container *ngFor="let content of toolbar.actions">
        <button type="button"
            *ngIf="content.btnIsToShowButton ? content.btnIsToShowButton(this.data) : true"
            [ngClass]="persCSSClassBtn" [disabled]="content.btnDisabled" class="btn btn-transparent"
            [title]="content.btnTitle"
            (keypress)="$event.keyCode === 13 ? onEvent($event, content.btnActionEvent):false"
            (click)="onEvent($event, content.btnActionEvent)">
            <!--<i *ngIf="content.btnIconClass" [title]="content.btnTitle" [ngClass]="content.btnIconClass" aria-hidden="true"></i>-->
            <span [ngClass]="persCSSClassIcon" *ngIf="content.btnIconClass" [title]="content.btnTitle"
                class="material-icons" aria-hidden="true">{{ content.btnIconClass }}</span>
        </button>
    </ng-container>
</div>
